import React from 'react'
import IconWrapper from './iconWrapper'
const DocIcon = () => (
  <IconWrapper width="30px" height="30px" >
    <g>
      <g>
        <path d="M463.996,126.864L340.192,3.061C338.231,1.101,335.574,0,332.803,0H95.726C67.724,0,44.944,22.782,44.944,50.784v410.434
          c0,28.001,22.781,50.783,50.783,50.783h320.547c28.002,0,50.783-22.781,50.783-50.783V134.253
          C467.056,131.482,465.955,128.824,463.996,126.864z M343.255,35.679l88.127,88.126H373.14c-7.984,0-15.49-3.109-21.134-8.753
          c-5.643-5.643-8.752-13.148-8.751-21.131V35.679z M446.158,461.217c0,16.479-13.406,29.885-29.884,29.885H95.726
          c-16.479,0-29.885-13.406-29.885-29.885V50.784c0.001-16.479,13.407-29.886,29.885-29.886h226.631v73.021
          c-0.002,13.565,5.28,26.318,14.871,35.909c9.592,9.592,22.345,14.874,35.911,14.874h73.018V461.217z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M275.092,351.492h-4.678c-5.77,0-10.449,4.678-10.449,10.449s4.679,10.449,10.449,10.449h4.678
          c5.77,0,10.449-4.678,10.449-10.449S280.862,351.492,275.092,351.492z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M236.61,351.492H135.118c-5.77,0-10.449,4.678-10.449,10.449s4.679,10.449,10.449,10.449H236.61
          c5.77,0,10.449-4.678,10.449-10.449S242.381,351.492,236.61,351.492z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M376.882,303.747H135.119c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h241.763
          c5.77,0,10.449-4.678,10.449-10.449C387.331,308.425,382.652,303.747,376.882,303.747z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M376.882,256H135.119c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h241.763
          c5.77,0,10.449-4.678,10.449-10.449C387.331,260.678,382.652,256,376.882,256z"/>
      </g>
    </g>
    <g>
      <g>
        <path d="M376.882,208.255H135.119c-5.77,0-10.449,4.678-10.449,10.449c0,5.771,4.679,10.449,10.449,10.449h241.763
          c5.77,0,10.449-4.678,10.449-10.449S382.652,208.255,376.882,208.255z"/>
      </g>
    </g>
  </IconWrapper>
)



export default DocIcon